import { render, staticRenderFns } from "./KitModal.vue?vue&type=template&id=ccfb2748&scoped=true"
import script from "./KitModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./KitModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfb2748",
  null
  
)

export default component.exports